import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";

import FormSelectionField from "../../components/formFields/FormSelectionField";

import { STATUSARRAY } from "../../_contstants/common";
// import FormImageUpload from "../../components/formFields/FormImageUpload";
import {
  DestinationImageUpload,
  createDestination,
  getDestinationByID,
  updateDestination,
} from "./services/destination.services";
import { clearDestinationDetails } from "./destinationSlice";

import FormTextArea from "../../components/formFields/FormTextArea";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateDestination: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const DestinationID = location.state?.DestinationID;
  const DestinationDetail = useAppSelector(
    (state) => state.destination.DestinationDetail
  );
  const loading = useAppSelector((state) => state.destination.loading);

  useEffect(() => {
    if (DestinationID) {
      dispatch(getDestinationByID(DestinationID));
    }
    return () => {
      dispatch(clearDestinationDetails());
    };
  }, [DestinationID]);

  const handleSubmit = async (values: any) => {
    const formData = {
      Title: values.Title ? values.Title : "",
      Description: values?.Description ? values?.Description : "",
      DestinationURL: values?.DestinationURL ? values?.DestinationURL : "",
      IsActive: values.IsActive === 1,
    };
    const ImageData = new FormData();
    const DestinationImg =
      values?.DestinationImg &&
      typeof values?.DestinationImg !== "string" &&
      Array.isArray(values?.DestinationImg) &&
      values?.DestinationImg?.length > 0
        ? values.DestinationImg[0]?.getRawFile()
        : "";
    const DestinationLogo =
      values?.DestinationLogo &&
      typeof values?.DestinationLogo !== "string" &&
      Array.isArray(values?.DestinationLogo) &&
      values?.DestinationLogo?.length > 0
        ? values.DestinationLogo[0]?.getRawFile()
        : "";
    try {
      if (DestinationID) {
        const editPayload = {
          ...formData,
          ID: DestinationID,
        };

        const response = await dispatch(updateDestination(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            (values?.DestinationImg &&
              typeof values?.DestinationImg !== "string" &&
              Array.isArray(values?.DestinationImg) &&
              values?.DestinationImg?.length > 0) ||
            (values?.DestinationLogo &&
              typeof values?.DestinationLogo !== "string" &&
              Array.isArray(values?.DestinationLogo) &&
              values?.DestinationLogo?.length > 0)
          ) {
            ImageData.append("DestinationImg", DestinationImg);
            ImageData.append("DestinationLogo", DestinationLogo);
            ImageData.append("ID", DestinationID);
            const imageResponse = await dispatch(
              DestinationImageUpload(ImageData)
            );
            if (imageResponse?.meta?.requestStatus === "fulfilled") {
              navigate("/destination");
            } else {
              navigate("/destination");
            }
          } else {
            navigate("/destination");
          }
        }
      } else {
        const response = await dispatch(createDestination(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            ((values?.DestinationImg &&
              typeof values?.DestinationImg !== "string" &&
              Array.isArray(values?.DestinationImg) &&
              values?.DestinationImg?.length > 0) ||
              (values?.DestinationLogo &&
                typeof values?.DestinationLogo !== "string" &&
                Array.isArray(values?.DestinationLogo) &&
                values?.DestinationLogo?.length > 0)) &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("DestinationImg", DestinationImg);
            ImageData.append("DestinationLogo", DestinationLogo);
            ImageData.append("ID", response?.payload?.Data?.ID);
            const imageResponse = await dispatch(
              DestinationImageUpload(ImageData)
            );
            if (imageResponse?.meta?.requestStatus === "fulfilled") {
              navigate("/destination");
            } else {
              navigate("/destination");
            }
          } else {
            navigate("/destination");
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div>
        <Form
          onSubmit={handleSubmit}
          initialValues={DestinationDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <ShadowCard style={{ padding: 12 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4>
                      {DestinationID
                        ? "Update Destination"
                        : "Create Destination"}
                    </Typography.h4>
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="Title"
                      label="Title"
                      placeholder="Title"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    rowSpan={2}
                    colSpan={2}
                    style={{ width: "100%", height: "100%" }}
                  >
                    <Field
                      name="Description"
                      label="Description"
                      component={FormTextArea}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem rowSpan={2}></GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="DestinationURL"
                      label="Destination (URL)"
                      placeholder="i.e /coaching/sat"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      display: "flex",
                      width: "100%",
                      gap: "10px",
                    }}
                  >
                    <Field
                      justifyContent="start"
                      name={`DestinationImg`}
                      label="Destination Image"
                      type="file"
                      accept="image/*"
                      style={{ width: 100 }}
                      alternateName="DestinationImg"
                      component={FormImageUploadMorden}
                    />
                    <Field
                      justifyContent="start"
                      name={`DestinationLogo`}
                      label="Destination Logo"
                      type="file"
                      accept="image/*"
                      alternateName="Destination Logo"
                      component={FormImageUploadMorden}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name={`IsActive`}
                      label="Status"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={STATUSARRAY?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={4}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={DestinationID ? "Update" : "Create"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/destination")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateDestination;
